<div class="d-flex">
  <div class="card w-100 form-right">
    <div class="back">
      <h2>{{ "inputs.select_addresses" | translate }}</h2>

      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form">
          <div>
            <div class="addresses-container">
              <div class="address-card" *ngFor="let address of addresses">
                <div class="icono">
                  <span>🏠</span>
                  <!--   <span *ngIf="address.tipo === 'comercial'">💼</span> -->
                </div>
                <div class="contenido">
                  <div class="direccion">{{ address.direccion }}</div>
                  <div class="detalles">
                    Código postal {{ address.cp }} - {{ address.localidad }}<br />
                  </div>
                </div>
                <div class="menu">⋮</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="d-flex justify-content-end mt-4">
        <button type="submit" class="btn btn-primary btn-primary-form">
          <span>
            {{ "buttons.add+" | translate }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
